import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import Image from "../../../base/features/micro/Image";
import actionHandler from "../../../base/utils/action_handler";
import checkOrientation from "../../../base/utils/check_orientation";

class DynamicSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="row mx-0 px-0 mb-4">
        {this.state.actionUrl && <Redirect push to={this.state.actionUrl} />}
        <div
          style={{
            color: this.props.view.title_color,
            fontSize: this.props.view.title_size + "px",
          }}
          className={`col-12 px-4 fw-bold`}
        >
          {this.props.view.title}
        </div>
        <div
          style={{
            overflow: "scroll hidden",
            whiteSpace: "nowrap",
          }}
          className="px-4 py-3 col-12 scrollbar-hide"
        >
          {this.props.view.items?.map((item, i) => (
            <div
              className="d-inline-block p-4 shadow-sm rounded28 ms-3 align-top h-100 text-center"
              style={{
                width: "42%",
                background: `linear-gradient(${checkOrientation(
                  item.background_color_orientation
                )}${item.background_color},${
                  item.background_color_end || item.background_color
                })`,
              }}
              onClick={() =>
                this.setState({
                  actionUrl: actionHandler(item.action, item.action_data),
                })
              }
            >
              <Image
                imageUri={item.media && item.media.file}
                imageHeight={"70"}
                imgClassName="w-100 img-cover rounded7 d-block mx-auto mb-3"
                extraClassName="w-50 d-block rounded14 p-2 mx-auto bg-secondary"
              />
              <div style={{ whiteSpace: "pre-wrap" }}>
                <p
                  className="mb-0 mt-2 fw-bold"
                  style={{
                    color: item.title_color,
                    fontSize: item.title_size + "px",
                    whiteSpace: "pre-wrap",
                  }}
                >
                  {item.title}
                </p>
                <p
                  className="mb-0 mt-2 fw-bold"
                  style={{
                    color: item.description_color,
                    fontSize: item.description_size
                      ? item.description_size + "px"
                      : "32px",
                  }}
                >
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default DynamicSummary;
